import { getErrorCodes } from '@/utils'
import { redemptionErrorsWhiteList } from '@/constants'

/**
 * Skip user registration if user is already registered with the current partner
 */
const shouldSkipRedemptionErrors = (errorData: any) => {
  const { errors } = errorData
  const genericErrors = getErrorCodes(errorData, ['error_details', 'base'])
  const formErrors = errors && Object.keys(errors)

  const hasErrors =
    [...genericErrors, ...formErrors].filter(
      (error: string) => !redemptionErrorsWhiteList.includes(error)
    ).length > 0

  return !hasErrors
}

export default shouldSkipRedemptionErrors
